<template>
  <div class="sect reco_shop_v2">
    <div class="list_tab">
      <button :class="{ on: isShopTab_1 }" @click="mainSelTab(1)">
        퍼스추천매장
      </button>
      <button :class="{ on: isShopTab_2 }" @click="mainSelTab(2)">
        관심매장<span>{{ shopFollowCount }}</span>
      </button>
    </div>
    <div class="list_tab_cont" ref="list_tab">
      <SkeletonStoreItem v-if="shopStarList.length < 1 && !starShopsView" />
      <div
        class="list_tab_cont_inner"
        v-if="isShopTab_1 && shopStarCount > 0 && starShopsView"
      >
        <ul class="shop_list" v-for="(items, keys) in shopStarList" :key="keys">
          <li
            class="pnt"
            v-for="(item, index) in items"
            :key="index"
            @click="goShopDetail(item)"
          >
            <div class="thumb_shop_wrap">
              <div class="thumb_image">
                <div class="thumb_image_inner" v-if="item.storeProfile">
                  <img :src="item.storeProfile" alt="" />
                </div>
                <div class="thumb_image_inner" v-else>
                  <img :src="setShopProfileImg(item.name, item.id)" alt="" />
                </div>
              </div>
            </div>
            <div class="txt">
              <h1>{{ item.name }}</h1>
              <dl>
                <dt>응답률</dt>
                <dd v-if="item.chatCnt > 0 && item.responseRate > 0">
                  {{ item.responseRate > 100 ? 100 : item.responseRate }}%
                </dd>
                <dd v-else style="padding:0 0.5rem">-</dd>
                <dd
                  v-if="
                    item.responseMinute >= 0 &&
                      item.responseMinute <= 10 &&
                      item.chatCnt > 0 &&
                      item.responseRate > 0
                  "
                  style="margin-left:0.2rem"
                >
                  (10분 이내)
                </dd>
                <dd
                  v-if="
                    item.responseMinute > 10 &&
                      item.responseMinute <= 30 &&
                      item.chatCnt > 0 &&
                      item.responseRate > 0
                  "
                  style="margin-left:0.2rem"
                >
                  (30분 이내)
                </dd>
                <dd
                  v-if="
                    item.responseMinute > 30 &&
                      item.responseMinute <= 60 &&
                      item.chatCnt > 0 &&
                      item.responseRate > 0
                  "
                  style="margin-left:0.2rem"
                >
                  (1시간 이내)
                </dd>
                <dd
                  v-if="
                    item.responseMinute > 60 &&
                      item.responseMinute <= 120 &&
                      item.chatCnt > 0 &&
                      item.responseRate > 0
                  "
                  style="margin-left:0.2rem"
                >
                  (2시간 이내)
                </dd>
                <dd
                  v-if="
                    item.responseMinute > 120 &&
                      item.responseMinute <= 360 &&
                      item.chatCnt > 0 &&
                      item.responseRate > 0
                  "
                  style="margin-left:0.2rem"
                >
                  (6시간 이내)
                </dd>
                <dd
                  v-if="
                    item.responseMinute > 360 &&
                      item.chatCnt > 0 &&
                      item.responseRate > 0
                  "
                  style="margin-left:0.2rem"
                >
                  (6시간 이상)
                </dd>
              </dl>

              <dl>
                <dt class="counseling_dt">상담</dt>
                <dd>{{ item.chatCnt }}건</dd>
              </dl>
            </div>
          </li>
        </ul>
      </div>
      <div
        class="list_tab_cont_inner_empty"
        v-if="isShopTab_1 && shopStarCount == 0 && starShopsView"
      >
        <div class="shop_list_empty">
          <div class="empty_img">
            <img src="@/assets/front/images/new/i_empty_n.svg" alt="" />
          </div>
          <div class="empty_txt_1">추천매장이 없습니다.</div>
          <div class="empty_txt_2">
            동네를 변경하여 추천매장을 확인해 보세요.
          </div>
        </div>
      </div>

      <div
        class="list_tab_cont_inner"
        v-if="isShopTab_2 && shopFollowCount > 0"
      >
        <ul
          class="shop_list"
          v-for="(items, keys) in shopFollowList"
          :key="keys"
        >
          <li
            class="pnt"
            v-for="(item, index) in items"
            :key="index"
            @click="goShopDetail(item)"
          >
            <div class="thumb_shop_wrap">
              <div class="thumb_image">
                <div class="thumb_image_inner" v-if="item.storeProfile">
                  <img :src="item.storeProfile" alt="" />
                </div>
                <div class="thumb_image_inner" v-else>
                  <img :src="setShopProfileImg(item.name, item.id)" alt="" />
                </div>
              </div>
            </div>
            <div class="txt">
              <h1>{{ item.name }}</h1>
              <dl>
                <dt>응답률</dt>
                <dd v-if="item.chatCnt > 0 && item.responseRate > 0">
                  {{ item.responseRate > 100 ? 100 : item.responseRate }}%
                </dd>
                <dd v-else style="padding:0 0.5rem">-</dd>
                <dd
                  v-if="
                    item.responseMinute >= 0 &&
                      item.responseMinute <= 10 &&
                      item.chatCnt > 0 &&
                      item.responseRate > 0
                  "
                  style="margin-left:0.2rem"
                >
                  (10분 이내)
                </dd>
                <dd
                  v-if="
                    item.responseMinute > 10 &&
                      item.responseMinute <= 30 &&
                      item.chatCnt > 0 &&
                      item.responseRate > 0
                  "
                  style="margin-left:0.2rem"
                >
                  (30분 이내)
                </dd>
                <dd
                  v-if="
                    item.responseMinute > 30 &&
                      item.responseMinute <= 60 &&
                      item.chatCnt > 0 &&
                      item.responseRate > 0
                  "
                  style="margin-left:0.2rem"
                >
                  (1시간 이내)
                </dd>
                <dd
                  v-if="
                    item.responseMinute > 60 &&
                      item.responseMinute <= 120 &&
                      item.chatCnt > 0 &&
                      item.responseRate > 0
                  "
                  style="margin-left:0.2rem"
                >
                  (2시간 이내)
                </dd>
                <dd
                  v-if="
                    item.responseMinute > 120 &&
                      item.responseMinute <= 360 &&
                      item.chatCnt > 0 &&
                      item.responseRate > 0
                  "
                  style="margin-left:0.2rem"
                >
                  (6시간 이내)
                </dd>
                <dd
                  v-if="
                    item.responseMinute > 360 &&
                      item.chatCnt > 0 &&
                      item.responseRate > 0
                  "
                  style="margin-left:0.2rem"
                >
                  (6시간 이상)
                </dd>
              </dl>

              <dl>
                <dt class="counseling_dt">상담</dt>
                <dd>{{ item.chatCnt }}건</dd>
              </dl>
            </div>
          </li>
        </ul>
      </div>
      <div
        class="list_tab_cont_inner_empty"
        v-if="isShopTab_2 && shopFollowCount == 0"
      >
        <div class="shop_list_empty">
          <div class="empty_img">
            <img src="@/assets/front/images/new/i_empty_n.svg" alt="" />
          </div>
          <div class="empty_txt_1">관심매장이 없습니다.</div>
          <div class="empty_txt_2">
            매장을 방문하여 관심매장을 등록해 보세요.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as util from '@common/lib/common/utils.js';

import { mapActions, mapState, mapGetters } from '@common/store/modules/shop';
import * as shopTypes from '@common/store/modules/shop/types';
import SkeletonStoreItem from '@/front/customer/views/home/components/SkeletonStoreItem.vue';

export default {
  // props: {
  //   shops: Object,
  // },
  components: {
    SkeletonStoreItem,
  },
  data() {
    return {
      isShopTab_1: true,
      isShopTab_2: false,
      shopFollowList: [],
      shopFollowCount: 0,
      shopStarList: [],
      shopStarCount: 0,
      PAGE: 1,
      PAGE_SIZE: 100,
      starShopsView: false,
    };
  },
  async created() {
    await this.getStarShops();
    await this.getFollowShops();
  },
  computed: {
    ...mapGetters({
      shops: shopTypes.SHOPS,
    }),
  },
  methods: {
    ...mapActions([shopTypes.FETCH_SHOPS, shopTypes.FETCH_RECOMMEND_SHOPS]),
    async getFollowShops() {
      const params = {
        follow: true,
        isNearby: false,
        page: this.PAGE,
        size: this.PAGE_SIZE,
        isLoading: false,
      };
      var shopData = await this[shopTypes.FETCH_SHOPS](params);

      this.shopFollowCount = shopData.content.length;

      var j = 0;
      var listCnt = Math.ceil(shopData.content.length / 3);
      for (var i = 0; i < listCnt; i++) {
        this.shopFollowList.push({ ...shopData.content.slice(j, j + 3) });
        j += 3;
      }
    },
    async getStarShops() {
      const params = {
        follow: false,
        isNearby: true,
        page: this.PAGE,
        size: this.PAGE_SIZE,
      };
      var shopData = await this[shopTypes.FETCH_RECOMMEND_SHOPS](params);

      this.shopStarCount = shopData.content.length;

      var j = 0;
      var listCnt = Math.ceil(shopData.content.length / 3);
      for (var i = 0; i < listCnt; i++) {
        if (j == 6) {
          break;
        }
        this.shopStarList.push({ ...shopData.content.slice(j, j + 3) });
        j += 3;
      }

      this.starShopsView = true;
    },
    mainSelTab(sel) {
      if (sel == 1) {
        this.isShopTab_1 = true;
        this.isShopTab_2 = false;
        this.$refs.list_tab.scrollLeft = 0;
      } else {
        this.isShopTab_1 = false;
        this.isShopTab_2 = true;
        this.$refs.list_tab.scrollLeft = 0;
      }

      const isShopTab = this.isShopTab_1 ? 'shopTab_1' : 'shopTab_2';
      this.$emit('setShopVisitPage', isShopTab);
    },
    goShopDetail(shop) {
      const isShopTab = this.isShopTab_1 ? 'shopTab_1' : 'shopTab_2';
      this.$emit('setShopVisitPage', isShopTab);
      this.$router.push({
        name: 'Shops.Detail',
        params: {
          id: shop.id,
        },
      });
    },
    setShopProfileImg(shopName, shopId) {
      let path = util.setShopProfile(shopName, shopId, '100x100', '18');

      return path;
    },
  },
};
</script>
